<template>
  <div>
    <div style="display: compact;">


      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'en'" v-for="(item, index) in blocksEN"  :key="`section__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>
      <transition-group name="fade" tag="div" mode="out-in">
        <div v-if="language === 'hu'" v-for="(item, index) in blocksHU"  :key="`section-hu__${index}`">
          <content-block
              :id="`section__${index}`"
              :title="item.title"
              :tools="item.tools"
              :date="item.date"
              :is-flex="item.isFlex"
              :content="item.content"
              :images="item.images" />
        </div>
      </transition-group>

    </div>


  </div>
</template>

<script>
import ContentBlock from "../components/ContentBlock";

export default {
  name: "Home",
  computed: {
    language: function() {
      return this.$store.getters.language;
    }
  },
  components: {
    ContentBlock
  },
  methods:{
    changeCategory(id){
      this.bioCategory = id;
    }
  },
  data: function() {
    return {
      bioCategory: 'contact',
      blocksEN: [
        {
          tools: 'Photo performance, 3 channel video, brooms',
          date: '2024',
          title: 'AND YET WE STILL KEEP ON LIVING…',
          content: `Zsuzsi Simon’s photo- and video-based work is centred on the human body as well as the examination of body-related taboos, stereotypes and stigmas, mainly through the filter of feminism. And yet we still keep on living…, her work made for the exhibition Maleficae – From Bonfires to Online Witchcraft at Budapest Gallery, also features active, independent female characters who influence the course of events and all of whom try to challenge a deep-rooted stereotype of women in society in the photo series capturing performances. Simon herself and her family members – her mother and grandmother – are the women participating in the photo-performances. In the three-channel video, which is closely linked to the photos but can also be interpreted separately, they talk about their (transgenerational) traumas as women while we see them perform ritual-performances together. The leitmotif spanning through the installation, the broom is a popular stereotype associated with witches, and by representing it as various types of ritual tool, Simon aims to give this cliché new meaning, reinforced by a series of ritualised movements. As an object used for cleaning, the broom is endowed with much greater, ritual significance in certain cultures, and thus also appears in Simon’s work as a symbol of purification and liberation. Through their own bodies and their honesty, the three women of different generations tell the story of women's commitment to a common destiny and family cohesion, as well as unleashing their own voices.
`,
          images: [
            { src: require("../assets/img/andyet/01_es_mi_meg_igy_is_tovab_elunk-01 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/02_es_mi_meg_igy_is_tovab_elunk-02 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/03_es_mi_meg_igy_is_tovab_elunk-03 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill2.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill3.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill4.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill5.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4431.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4436.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4451.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4460.jpg"), claimed: false },
            { src: require("../assets/img/andyet/Maleficae_Megnyito_W02.jpg"), claimed: false },
            { src: require("../assets/img/andyet/Maleficae_Megnyito_W82.jpg"), claimed: false }


          ]
        },
      ],
      blocksHU: [
        {
          tools: 'Fotóperformansz, 3 csatornás videó, seprűk',
          date: '2024',
          title: "ÉS MI MÉG ÍGY IS TOVÁBB ÉLÜNK…",
          content: `Simon Zsuzsi fotó- és videóalapú munkásságának az emberi test áll a középpontjában, a testtel kapcsolatos tabuk, sztereotípiák, stigmák főként feminista szűrőn keresztüli vizsgálata. A Budapest Galéria Maleficae – A máglyától az online varázslásig című kiállítására készült és mi mégis tovább élünk… szereplői is aktív, a történéseket befolyásoló, független női karakterek, akik mind egy, a társadalomban mélyen gyökerező, nőkkel kapcsolatos előítéletet próbálnak megdönteni a performanszokat rögzítő fotósorozaton. A fotóperfomanszokon maga Simon, valamint családtagjai - édesanyja és nagyanyja - vesznek részt, a fotókhoz szorosan kapcsolódó, de külön is értelmezhető háromcsatornás videóban pedig a nőként őket ért (transzgenerációs) traumákról beszélnek, három mialatt közösen előadott rituálé-performanszot láthatunk. Az installáció egyes elemeit összekötő fő motívum, a seprű egy a boszorkányokhoz köthető népszerű sztereotípia, melynek különböző rituális eszközökként való ábrázolásával Simon pont ennek a közhelynek szeretne új értelmezést adni. A seprű, mint takarításra használt tárgy bizonyos kultúrákban sokkal nagyobb, rituális jelentőséggel van felruházva, így Simon munkájában is a megtisztulás szimbólumaként jelenik meg, amit rítusossá összeálló mozdulatsorok is csak erősítenek. A három eltérő generációhoz tartozó nő saját testükön és őszinteségükön keresztül saját hangjuk felszabadítása mellett a női sorsközösség vállalásának és a családi összetartásnak a történetét is elmeséli.`,
          images: [
            { src: require("../assets/img/andyet/01_es_mi_meg_igy_is_tovab_elunk-01 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/02_es_mi_meg_igy_is_tovab_elunk-02 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/03_es_mi_meg_igy_is_tovab_elunk-03 copy.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill2.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill3.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill4.jpg"), claimed: false },
            { src: require("../assets/img/andyet/es_mi_videostill5.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4431.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4436.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4451.jpg"), claimed: false },
            { src: require("../assets/img/andyet/IMG_4460.jpg"), claimed: false },
            { src: require("../assets/img/andyet/Maleficae_Megnyito_W02.jpg"), claimed: false },
            { src: require("../assets/img/andyet/Maleficae_Megnyito_W82.jpg"), claimed: false }
          ]
        },
      ]
    };
  }
};
</script>

<style scoped>
.selector p{
  margin-right: 20px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}
</style>
